

const initialState = null; // Initial state

const callinfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CALLINFO':
        console.log("SET_CALLINFO",action);
      return action.payload; // Set the session value
    
    default:
      return state;
  }
};

export default callinfoReducer;


